import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import VehicleComplexityMatrix from "../../components/vehicleComplexity/VehicleComplexityMatrix";
import Card from "../../components/shared/Card/Card";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { CheckFeatureFlag } from "../../hooks/useFeatureFlag";
import useCustomerDetails from "../../data/useCustomerDetails";
import LoadingWheel from "../../components/shared/LoadingWheel";

export default function VehicleComplexity() {
  const { t } = useTranslation("vehicles");
  const { setInfo } = usePageNameContext();
  const { features } = useCustomerDetails();
  const isTme = CheckFeatureFlag("TME");

  useEffect(() => {
    setInfo({
      name: "Vehicle Complexity",
      desc: "Grade vehicles by make and model, and see how other sites grade them",
    });
  }, []);

  // The route is registered unconditionally - the router is built before feature flags load - so the
  // gate lives here. Wait for the flags before deciding, or a TME user hitting the URL directly would
  // see "not available" for a moment before the page appeared.
  if (features.isLoading && !features.data) {
    return (
      <Card title={t("Vehicle Complexity")} bodyClassName="p-4">
        <div className="py-10">
          <LoadingWheel />
        </div>
      </Card>
    );
  }

  if (!isTme) {
    return (
      <Card title={t("Vehicle Complexity")} bodyClassName="p-4">
        <p className="py-6 text-sm text-gray-600">
          {t(
            "Vehicle complexity rules are not enabled for your business. Vehicles are graded from the most recent vehicle of the same type instead."
          )}
        </p>
      </Card>
    );
  }

  return (
    <Card title={t("Vehicle Complexity")} bodyClassName="p-4">
      <VehicleComplexityMatrix />
    </Card>
  );
}
